export const mapKey = {}
export const markerKey = {}
export const sourceKey = {}
